<template>
    <button
        class="btn-option-phonemic-consonant"
        :class="selectionClass">
        <span class="btn-option-phonemic-consonant__text">{{ optionText }}</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            featureType:    { type: String, default: 'lorem' },
            optionSlug:     { type: String, default: 'lorem' },
            optionText:     { type: String, default: 'Lorem' },
        },

        computed: {
            selectionClass(){
                let answerDataFeatureValue = this.$store.state.answerData.consonantFeatures[this.featureType];
                if(answerDataFeatureValue === this.optionSlug){
                    return 'btn-option-phonemic-consonant--selected';
                }
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-option-phonemic-consonant.css"></style>